import Client from "./clients/rest";

export default {
  get(id) {
    const targetUrl = id ? `/business/${id}` : "/business";
    return Client.get(targetUrl);
  },
  postContactUs(
    business_id,
    name,
    email,
    subject,
    description,
    sub_subject,
    captcha
  ) {
    return Client.post(
      `business/${business_id}/contactus`,
      {
        name: name,
        email: email,
        subject: subject,
        description: description,
        sub_subject: sub_subject,
      },
      {
        headers: { "X-CAPTCHA": captcha },
      }
    );
  },

  getInvoices({ business_id, from, to, top = null }) {
    return Client.get(`business/${business_id}/invoices`, {
      params: {
        from,
        to,
        take: top,
      },
    });
  },

  async exportInvoices(business_id, data) {
    try {
      const response = await Client.post(
        `business/${business_id}/invoices/export`,
        JSON.stringify(data),
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
          validateStatus: (status) => status < 500,
        }
      );

      if (response.status === 200) {
        return response.data;
      }

      const errorJsonText = await response.data.text();
      const errorData = JSON.parse(errorJsonText);

      throw new Error(
        errorData.message || "An error occurred while preparing the file."
      );
    } catch (error) {
      throw error;
    }
  },

   getOrders: (businessId, config = {}) => {
       return Client.get(`business/${businessId}/orders`, config);
   },

  deleteOrder(business_id, order_id) {
    return Client.delete(`business/${business_id}/order`, {
      params: {
        order_id,
      },
    });
  },

  approveOrder(business_id, order_id) {
    return Client.put(
      `business/${business_id}/order`,
      JSON.stringify(order_id)
    );
  },

  getInvoicesMishlohim({ business_id, from, to }) {
    return Client.get(`business/${business_id}/mishlohim-invoices`, {
      params: {
        from,
        to,
      },
    });
  },

  getEzcountInvoices({ business_id, from, to }) {
    return Client.get(`business/${business_id}/ezcount-invoices`, {
      params: {
        from,
        to,
      },
    });
  },

  getZapXInvoices({ business_id, from, to, email }) {
    return Client.get(`business/${business_id}/zapx-invoices`, {
      params: {
        from,
        to,
        email,
      },
    });
  },
  getTabsInvoices(business_id) {
    return Client.get(`business/${business_id}/invoices-tabs`, {});
  },

  getInvoicesFile(business_id, obj) {
    return Client.post(`business/${business_id}/invoices`, obj);
  },

  async getInvoiceFileBlob(business_id, fileName) {
    const response = await Client.get(
      `business/${business_id}/invoices/download/${fileName}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  },

  getPromotions(businessId) {
    return Client.get(`business/${businessId}/promotions`);
  },

  updateBusinessSiteTag(businessId, siteId, tagId, payload, admin) {
    return Client.put(
      `business/${businessId}/sites/${siteId}/tags/${tagId}${
        admin ? "/Admin" : ""
      }`,
      payload
    );
  },

  updateBusinessInfo(
    business_id,
    name,
    sso_customer_type,
    sso_user_id,
    sso_user_email,
    business_number,
    id,
    type,
    mainPrefix,
    mainPhoneNumber,
    web_site,
    email,
    email_invoice,
    city_code,
    city_name,
    street_code,
    street_name,
    house_number,
    slogan,
    languages,
    description,
    facebook_url,
    instagram_url,
    tiktok_url,
    firstName,
    lastName,
    prefix,
    number,
    role,
    status,
    class_id,
    class_name
  ) {
    const prams = {
      name: name,
      business_id: business_id,
      sso_customer_type: sso_customer_type,
      sso_user_id: sso_user_id,
      sso_user_email: sso_user_email,
      business_number: business_number,
      phones: [
        {
          id: id,
          type: type,
          prefix: mainPrefix,
          number: mainPhoneNumber,
        },
      ],
      web_site: web_site,
      email: email,
      email_invoice: email_invoice,
      address: {
        city_code: city_code,
        city_name: city_name,
        street_code: street_code,
        street_name: street_name,
        house_number: house_number,
      },
      slogan: slogan,
      languages: languages,
      description: description,
      facebook_url: facebook_url,
      instagram_url: instagram_url,
      tiktok_url: tiktok_url,
      owner: {
        id: id,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: {
          id: id,
          type: type,
          prefix: prefix,
          number: number,
        },
        isOwner: true,
        role: role,
        isMainContact: true,
      },
      sub_bussnisses: [
        {
          name: name,
          business_id: business_id,
          is_main: true,
          email: email,
          sso_customer_type: 0,
        },
      ],
      verticals: [
        {
          id: 0,
          name: name,
          status: status,
          class_id: class_id,
          class_name: class_name,
        },
      ],
    };
    return Client.put(`business/${business_id}`, prams);
  },

  getImages(business_id, vertival_id) {
    return Client.get(
      `business/${business_id}/verticals/${vertival_id}/images`
    );
  },
  getOpeningHours_OLD(businessId, verticalId = 0) {
    return Client.get(
      `business/${businessId}/verticals/${verticalId}/openinghours`
    );
  },
  updateOpeningHours_OLD(businessId, verticalId = 0, payload) {
    return Client.put(
      `business/${businessId}/verticals/${verticalId}/openinghours`,
      payload
    );
  },

  upsertCalls(businessId, payload) {
    return Client.put(`business/${businessId}/callsDetails`, payload);
  },

  callsObjection(businessId, payload) {
    return Client.post(`business/${businessId}/callsObjection`, payload);
  },

  getCallRecording(businessId, call_uuid, verticl) {
    return Client.get(`business/${businessId}/callrecording`, {
      params: {
        call_uuid,
        verticl,
      },
    });
  },

  getCallsDetails(businessId, from, to) {
    return Client.get(`business/${businessId}/callsDetails`, {
      params: {
        from,
        to,
      },
    });
  },

  getContacts(businessId) {
    return Client.get(`business/${businessId}/contacts`);
  },

  getCalls(businessId, from, to, limit, offset, filter) {
    const filters = filter ? JSON.stringify(filter.filter(Boolean)) : null;

    return Client.post(
      `business/${businessId}/calls?from=${from}&to=${to}&offset=${offset}&limit=${limit}`,
      filters
    );
  },

  downloadCalls(businessId, from, to, filter, limit) {
    const filters = filter ? JSON.stringify(filter.filter(Boolean)) : null;

    return Client.post(
      `business/${businessId}/calls/download?from=${from}&to=${to}&limit=${limit}`,
      filters
    );
  },

  downloadMyCalls(businessId, from, to, status) {
    return Client.get(`business/${businessId}/callsdetails/download`, {
      params: {
        from,
        to,
        status,
      },
    });
  },

  getReviews(businessId /*, page = 1, pageSize = 5*/) {
    return Client.get(`business/${businessId}/reviews`, {
      // page, pageSize
    });
  },
  getTotalReviews(businessId, vertical = "main") {
    return Client.get(`business/${businessId}/reviews/total`, {
      params: {
        vertical,
      },
    });
  },
  reviewResponse(businessId, reviewId, body, responseId) {
    // responseId === 0 for new ones
    return Client.put(
      `business/${businessId}/reviews/${reviewId}/response/${responseId}`,
      body
    );
  },
  reviewSendWhatsapp(business_id, body) {
    return Client.put(`business/reviews/${business_id}/sendwhatsapp`, body);
  },
  reviewDelete(businessId, reviewId, responseId, payload) {
    return Client.delete(
      `business/${businessId}/reviews/${reviewId}/response/${responseId}`,
      { data: payload }
    );
  },

  getAds(business_id, category_id) {
    return Client.get(`business/${business_id}/advertisings`, {
      params: {
        category_id,
      },
    });
  },

  deleteContact(businessId, contactId) {
    return Client.delete(`business/${businessId}/contacts/${contactId}`);
  },

  updateContact(businessId, body) {
    return Client.put(`business/${businessId}/contacts`, body);
  },

  getOpeningHours(business_id) {
    return Client.get(`business/${business_id}/openinghours`);
  },

  updateOpeningHours(business_id, payload) {
    return Client.put(`business/${business_id}/openinghours`, payload);
  },

  getOpeningHoursTiming(business_id, timing_id) {
    return Client.get(
      `business/${business_id}/openinghours/timing/${timing_id}`
    );
  },

  updateOpeningHoursTiming(business_id, payload) {
    return Client.put(`business/${business_id}/openinghours/timing`, payload);
  },
  getOperationHistory(business_id, from, to) {
    return Client.get(`business/${business_id}/operation-history`, {
      params: {
        from,
        to,
      },
    });
  },
  getChangeRequests(business_id, form_name, status) {
    return Client.get(`business/change-requests`, {
      params: { business_id, form_name, status },
    });
  },
};
